import * as validateFns from 'Data/validate.js'

export function filterFlowQuestions(questions, answers) {
  return questions
    .filter(item => {
      if (item.hidden) return false

      if (!Array.isArray(item.depends_on) || item.depends_on?.length === 0)
        return true

      return item.depends_on.every(dep => {
        let validate = validateFns?.[dep.validation]
        // the boolean is not within an answer object
        return validate(answers[dep.id]?.value || answers[dep.id], dep?.value)
      })
    })
    .map(item => item.id)
}
